import { useTranslation } from 'react-i18next';
import CategoryRadarSection from './shared/CategoryRadarSection';
import type { TeamResilienceStatistic } from './shared/utils';

interface TeamResilienceResultProps {
    statistics: TeamResilienceStatistic;
    summaryFormation?: number[];
}

const TeamResilienceResult = ({ statistics, summaryFormation = [3] }: TeamResilienceResultProps) => {
    const { t } = useTranslation('assessmentResultManagementPage');

    return (
        <CategoryRadarSection
            statistics={{
                domainMax: statistics.domainMax,
                radarData: statistics.radarData,
                summaryCards: statistics.summaryCards,
                tickCount: statistics.tickCount,
            }}
            summaryFormation={summaryFormation}
            summaryValueDecimals={1}
            tooltipValueLabel={t('details.teamResilience.yourScore')}
            tooltipAxisLabel={t('details.teamResilience.subcategory')}
            chartMargin={{ top: 20, bottom: 0 }}
        />
    );
};

export default TeamResilienceResult;
